import React, { useState, useEffect } from "react";
import Offcanvas from 'react-bootstrap/Offcanvas';

import { Row, Col, Button } from "react-bootstrap";
import ConfettiSmallIcon from "../images/confetti-small-icon.svg";

const LetsGetMoboffcanvas = (props) => {
  const {show, onHide} = props;
  return (

    <Offcanvas
     className="mobile-offcanvas"
     show={show}
      onHide={onHide}
      placement='bottom'
      {...props}>
    <Offcanvas.Header className="d-none" closeButton>
      <Offcanvas.Title>Offcanvas</Offcanvas.Title>
    </Offcanvas.Header>
    <Offcanvas.Body>
      
      <h2 className="mt-2 mb-4">Let’s get whatcha want! What would you like to do first?</h2>
    
      <div className="offcanvas-content-wrap mb-3">
      <h4>Create a want-ad</h4>
        <p>You have a client seeking property to purchase, rent long-term or stay-in for vacation. Publicly list their wants & needs and let those with the right property come to you.</p>
      </div>
      <div className="offcanvas-content-wrap mb-4">
        <h4>Add property to private inventory</h4>
        <p>You have a client with property to sell or rent-out. We will match your property to want-ads, and you can privately introduce your property to buyers 
and renters.</p>
      </div>
      <div className="btn-wrap text-center pb-4">
                          <button type="button" class="btn btn-primary w-100 mb-4" disabled>Start</button>
                         
                          <a href="#" class="blue-text-link">Let me look around first</a>
                  
                        </div>
    </Offcanvas.Body>
  </Offcanvas>



    
  );
};
export default LetsGetMoboffcanvas;
